import * as yup from 'yup';

import { t } from '@/services/translations/config';

const patternTwoDigitsAfterComma = /^\d+(\.\d{0,2})?$/;

const createInvoicingProductForm = yup.object().shape({
    name: yup.string().trim().required(t('Procedure:error:name_required')),
    price: yup
        .string()
        .transform((_value, originalValue) => originalValue.replace(/,/, '.'))
        .test(
            'is-number',
            t('Procedure:validation:not_number'),
            (val: string) => {
                if (val !== undefined) {
                    return !isNaN(Number(val));
                }
                return true;
            },
        )
        .test(
            'is-decimal',
            t('Procedure:validation:decimal_case'),
            (val: string) => {
                if (val !== undefined) {
                    return patternTwoDigitsAfterComma.test(val);
                }
                return true;
            },
        )
        .required(t('Procedure:error:price_required')),
    available: yup.boolean(),
});

export const InvoicingProductValidationSchema = { createInvoicingProductForm };
